'use client';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsVolop } from '#/modules/search/constants/useSearchFacetsVolop';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { searchShouldShowSortOptions } from '#/modules/search/helpers/searchShouldShowSortOptions';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

export function SearchVolopsPage() {
  const { i18n } = useI18n();

  const filters = useSearchFiltersByName();
  const query = useSearchQuery();

  const location = useLocation();
  useEffect(() => {
    trackPageView('Search Volops');
  }, [location.key]);

  const { volopSearchFacets } = useSearchFacetsVolop(i18n);

  return (
    <SearchPage
      searchFacets={volopSearchFacets}
      searchType="VOLOP"
      showSortOptions={searchShouldShowSortOptions({
        searchType: 'VOLOP',
        query,
        filters,
      })}
    />
  );
}
